import type { ReactNode } from 'react';

interface Props {
  /** Vorgelesener Name der Vorschau, etwa „Handy-Vorschau Anfahrt“. */
  label: string;
  language: 'de' | 'en';
  /** Kopf des Portals — die Marke des Objekts; ohne sie ein neutraler Kopf. */
  brand?: ReactNode;
  children: ReactNode;
}

/**
 * Ein Telefon im Look des Gastportals für Vorschauen im Admin. Die Farben und Schriften kommen aus
 * dem `.guest-portal`-Scope — dieselben wie beim Gast, keine Nachbildung.
 */
export function GuestPhoneFrame({ label, language, brand, children }: Props) {
  return (
    <section
      role="region"
      aria-label={label}
      className="guest-portal border-ink/85 shadow-card mx-auto w-full max-w-[20rem] overflow-hidden rounded-[1.75rem] border-[6px]"
    >
      <header className="border-line bg-bg-elev flex min-h-12 items-center justify-between gap-2 border-b px-4 py-2.5">
        <div className="min-w-0">
          {brand ?? <span className="text-fg font-display text-sm font-semibold">Gastportal</span>}
        </div>
        <span className="border-line text-fg-mute shrink-0 rounded-md border px-1.5 py-0.5 font-mono text-[10px] uppercase">
          {language}
        </span>
      </header>
      <div className="bg-bg max-h-[36rem] space-y-4 overflow-y-auto px-4 py-5">{children}</div>
      <footer className="border-line bg-bg text-fg-mute border-t px-4 py-2.5 text-center font-mono text-[9px] tracking-[0.12em]">
        Powered by StayOn
      </footer>
    </section>
  );
}
